import { Component } from '@angular/core';
import { Router } from '@angular/router';

import {Idle, DEFAULT_INTERRUPTSOURCES} from '@ng-idle/core';
import {Keepalive} from '@ng-idle/keepalive';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  idleState: boolean = false;
  timedOut: boolean = false;
  idleStateMessage: string = '';

  constructor(
    private router: Router,
    private idle: Idle,
    private keepalive: Keepalive
    ){
    // sets an idle timeout.
    idle.setIdle(45);
    // After :45 of inactivity, the user will be considered timed out.
    idle.setTimeout(10);
    // sets the default interrupts
    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    idle.onIdleEnd.subscribe(() => this.idleState = false);
    idle.onTimeout.subscribe(() => {
      this.idleState = false;
      if(this.router.url !== '/scanticket') {
        this.router.navigate(['/scanticket']);
      }
    });

    idle.onIdleStart.subscribe(() => {
      console.log('idle started')
      if(this.router.url !== '/scanticket') {
        this.idleState = true;
      } else {
        this.reset();
      }
    });
    idle.onTimeoutWarning.subscribe((countdown) => this.idleStateMessage = countdown);

    // sets the ping interval to 15 seconds
    keepalive.interval(15);

    this.reset();
  }

  reset() {    
    this.idleState = false;
    this.timedOut = false;
  }
}



// WEBPACK FOOTER //
// C:/Magento2/gs-kiosk/src/app/app.component.ts